import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'loyaltyCardsFilter', namespaced: true })
export default class LoyaltyCardsFilter extends FilterModule {
    constructor(module: LoyaltyCardsFilter) {
        super(module);
    }
}
